import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';
import { string } from 'yup';

const toast = useToast();
const useFooterStore = defineStore({
    id: 'footer',
    state: () => ({
        isShowWebchat: false,
        siteMapList: [
            {
                title: 'Corporate',
                itemList: [
                    'sitemap.aboutcorporate',
                    'sitemap.healthSolutions',
                    'sitemap.preventWell',
                    'sitemap.healthAnalytics',
                    'sitemap.employHealthMan',
                    'sitemap.medicalAdvis',
                    // 'sitemap.contactUs',
                ]
            },
            {
                title: 'Insurer',
                itemList: [
                    'sitemap.aboutinsurer',
                    'sitemap.networkDoctors',
                    'sitemap.costContain',
                    'sitemap.callCenterServices',
                    // 'sitemap.contactUs',
                ]
            },
            {
                title: 'Patient',
                itemList: [
                    'sitemap.aboutpatients',
                    'sitemap.patientExp',
                    'sitemap.healthOptim',
                    'sitemap.diseaseMan',
                    'sitemap.doctorRef',
                    'sitemap.homeCare',
                    // 'sitemap.contactUs',
                ]
            },
            {
                title: 'Services',
                itemList: [
                    'sitemap.aboutservices',
                    'sitemap.corporatePack',
                    'sitemap.advisory',
                    'sitemap.checkupServe',
                    'sitemap.telemedicine',
                    'sitemap.tpa',
                    'sitemap.outpatientServ',
                    'sitemap.vaccinations',
                    'sitemap.nursingServ',
                    'sitemap.emergencyAss',
                    'sitemap.prodProc',
                ]

            },
            {
                title: 'About Us',
                itemList: [
                    'sitemap.ourValues',
                    'sitemap.ourTeam',
                    'sitemap.ourServ',
                    'sitemap.ourFac',
                ]
            },
            {
                title: 'Investor Relations',
                itemList: [
                    'sitemap.valueAdd',
                    'sitemap.investorReturns',
                    'sitemap.expanOpp',
                ]
            },
            {
                title: 'Work With Us',
                itemList: [
                    'sitemap.joinOurNet',
                    // 'sitemap.forHealthPro',
                    'sitemap.whythe',
                    // 'sitemap.carOpp',
                ]
            },
            {
                title: 'Book Your Appointment',
                itemList: [
                    'sitemap.whatWePhone',
                    // 'sitemap.appointForm',
                ]
            },
            {
                title: 'Corporate Member Login',
                itemList: [
                    'sitemap.doctorList',
                ]
            },
        ],

    }),
    getters: {},
    actions: {
        async contactUs(body: object) {
            try {
                console.log('api: contact us: ' + JSON.stringify(body));
                const response: any = await apiClient.post('/api/scwebsite/contactUs/', body);
                const isSuccess = response.statusCode;
                //debugger;
                if (!isSuccess) {
                    console.log('response? ' + JSON.stringify(response));
                    var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    throw new Error(error)
                }
                toast.success('Send Email Success');
                return isSuccess;
            } catch (err: any) {
                toast.error(err.message);
            }
        },
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useFooterStore, import.meta.hot));
}

export { useFooterStore };
